import axios from "axios";
import moment from "moment";
import { store } from "../store";
import { toast } from "react-toastify";
import { setLoading } from "../store/reducers/base";

const FileSaver = require('file-saver');

export const validateForm = (formData, t, options = {}) => {
    let isValid = [];
    const newErrors = { ...formData }

    Object.entries(formData).forEach(([key, value]) => {
        if (newErrors[key]?.hasOwnProperty("error")) {

            if (!value?.hasOwnProperty("is_visible_edit")) {
                if (typeof value?.value === "boolean") {
                    newErrors[key].error = "";
                } else if (value?.isrequired && !value?.value) {
                    newErrors[key].error = t('common.required');
                    isValid.push(false);
                } else {
                    newErrors[key].error = "";
                }
                if (typeof value?.validation === 'function' && value?.value) {
                    const validation = value?.validation(value?.value);
                    if (validation == false) {
                        newErrors[key].error = t('common.invalid');
                        isValid.push(false);
                    } else {
                        newErrors[key].error = "";
                    }
                }
            } else {
                if (value?.is_visible_edit == true && options?.isedit == true) {
                    if (value?.isrequired && !value?.value) {
                        newErrors[key].error = t('common.required');
                        isValid.push(false);
                    } else {
                        newErrors[key].error = "";
                    }
                    if (typeof value?.validation === 'function' && value?.value) {
                        const validation = value?.validation(value?.value);
                        if (validation == false) {
                            newErrors[key].error = t('common.invalid');
                            isValid.push(false);
                        } else {
                            newErrors[key].error = "";
                        }
                    }
                }
            }

        }
    });

    return { isValid: isValid?.length === 0, newErrors };
};

export const validate = {
    email: (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    },
    postalCode: (postalCode) => {
        const postalCodeRegex = /^\d{5}$/;
        return postalCodeRegex.test(postalCode);
    },
    phoneNumber: (phoneNumber) => {
        const phonePattern = /^[+0-9\s-]*$/;
        // if (phoneNumber?.length > 20) {
        //     return false;
        // }
        return phonePattern.test(phoneNumber);
    },
    isValidUri: (uri) => {
        try {
            // Check if the URI has multiple URLs concatenated
            if (uri.includes('http') && (uri.match(/http/g) || []).length > 1) {
                return false;
            }

            // Try to create a URL object (will throw if invalid)
            new URL(uri);

            // Additional checks for common patterns
            const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
            return urlPattern.test(uri);
        } catch (e) {
            return false;
        }
    }
};

export const handleChange = (e, setFormData) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: { ...prev[name], value: value } }));
};

export const formatAddress = (formData) => {
    const parts = [];
    if (formData?.street) parts.push(formData?.street);
    if (formData?.pincode) parts.push(formData?.pincode);
    if (formData?.city) parts.push(formData?.city);
    if (formData?.country) parts.push(formData?.country);

    return parts.join(', ');
};

export const format = {
    number: (number) => {
        return number ? new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: true
        }).format(number) : ""
    },
    calculateDaysUntilExpiry: (expiryDate) => {
        if (!expiryDate) return null;
        const expiry = moment(expiryDate).startOf('day');
        const now = moment().startOf('day');
        const diff = expiry.diff(now, 'days');
        return diff >= 0 ? diff : 0;
    },
    calculateIsAfter: (startDate, days = 1) => {
        const expiry = moment(startDate).add(days, 'days')
        const now = moment()
        return now.isSameOrAfter(expiry, "days")
    },
    money: (number) => {
        return number ? new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number) : ""
    },
    date: (date) => {
        return date ? moment(date).format("DD.MM.YYYY") : "";
    },
    datetime: (date, ss = "HH:mm") => {
        return date ? moment(date).format(`DD.MM.YYYY ${ss}`) : "";
    },
    time: (date, format = 12) => {
        return date ? moment(date).format(format === 12 ? "hh:mm A" : "HH:mm") : "";
    },
    delay: (date) => {
        return date ? moment(date).format("DD.MM.YYYY") : "";
    },
    monthYear: (date) => {
        return date ? moment(date).format("MM.YYYY") : "";
    },
}

export const getFileNameFromUrl = (url) => {
    try {
        if (!url) return "";
        const urlObj = new URL(url);
        return urlObj?.pathname?.split('/')?.pop();
    } catch (error) {
        return ""
    }
};

export const getFileInfo = (value) => {
    const isFile = value && typeof value === 'object' && value?.name && value?.size !== undefined && value?.type !== undefined;
    if (isFile) {
        return { previewUrl: URL.createObjectURL(value), fileName: value?.name }
    } else {
        if (typeof value === 'string') {
            return { previewUrl: value, fileName: getFileNameFromUrl(value) }
        }
    }
};

export const openFileOrUrl = (e, value) => {
    if (e) {
        e.stopPropagation();
    }
    if (!value || !validate?.isValidUri(value)) {
        toast.error("Invalid file URL");
        return;
    }
    if (value instanceof File || value instanceof Blob) {
        // For files, create a temporary URL and open in new tab
        const url = URL.createObjectURL(value);
        window.open(url, '_blank');
        // Clean up the URL object
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    } else {
        // For URLs, just open in new tab

        window.open(value, '_blank');
    }
};

export const downloadFile = async (value) => {
    try {
        // window.open(value, '_blank')
        // return
        // openFileOrUrl(null, value)
        // return
        if (process.env.NODE_ENV === 'development') {
            openFileOrUrl(null, value)
            return
        }
        if (!value || !validate?.isValidUri(value)) {
            toast.error("Invalid file URL");
            return;
        }
        store.dispatch(setLoading(true))
        const response = await axios.get(value, {
            responseType: 'blob',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/octet-stream',
            }
        });

        // Get filename from content-disposition header if available
        const contentDisposition = response.headers['content-disposition'];
        let filename = 'download';
        if (contentDisposition) {
            const filenameRegex = /filename[^;=\n]=((['"]).?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
        }

        // If no filename from header, try to get from URL
        if (filename === 'download') {
            const url = new URL(value);
            const urlFilename = url.pathname.split('/').pop();
            if (urlFilename) {
                filename = urlFilename;
            }
        }

        // Get content type
        const contentType = response.headers['content-type'] || 'application/pdf';
        const blob = new Blob([response.data], { type: contentType });

        // Save the file
        store.dispatch(setLoading(false))
        FileSaver.saveAs(blob, filename);

    } catch (error) {
        store.dispatch(setLoading(false))
        if (error?.response?.status === 404) {
            toast.error("File not found");
        } else if (error?.response?.status === 403) {
            toast.error("Access denied");
        } else {
            toast.error("Error downloading file");
        }
    }
};